module.exports = __webpack_public_path__ + "static/media/km_phone.30fbc6cd.png";